import { BrowserRouter, Link, Navigate, Route, Routes } from 'react-router-dom'
import { PwaShell } from './components/pwa/PwaShell'
import { I18nProvider } from './i18n'
import { AnchorEditor } from './routes/AnchorEditor'
import { CloudSync } from './routes/CloudSync'
import { DataManagement } from './routes/DataManagement'
import { Disclaimer } from './routes/Disclaimer'
import { KataLibrary } from './routes/KataLibrary'
import { KataJudge } from './routes/KataJudge'
import { KataPerformances } from './routes/KataPerformances'
import { KataPractice } from './routes/KataPractice'
import { UserManual } from './routes/UserManual'
import { VideoSetup } from './routes/VideoSetup'

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <PwaShell>
          <Routes>
            <Route path="/" element={<KataLibrary />} />
            <Route path="/manual" element={<UserManual />} />
            <Route path="/cloud-sync" element={<CloudSync />} />
            <Route path="/data" element={<DataManagement />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/kata/:kataId" element={<KataPractice />} />
            <Route path="/kata/:kataId/setup" element={<VideoSetup />} />
            <Route path="/kata/:kataId/edit" element={<AnchorEditor />} />
            <Route path="/kata/:kataId/performances" element={<KataPerformances />} />
            <Route path="/kata/:kataId/judge" element={<KataJudge />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <footer aria-label="Legal information" style={{ textAlign: 'center', padding: '16px 16px 32px', fontSize: '14px' }}>
            <Link to="/disclaimer">Legal Disclaimer / <span lang="zh-Hant">免責聲明</span></Link>
          </footer>
        </PwaShell>
      </BrowserRouter>
    </I18nProvider>
  )
}
